export const GLOBAL_BORDER_RADIUS = 10 as const // [px]
export const BUTTON_BORDER_RADIUS = 5 as const // [px]
export const TOOLBAR_HEIGHT = 65 as const // [px]
export const CONTAINER_BOTTOM_SPACING = 3 as const // [px]
export const INPUT_WIDTH = 350 as const // [px]
export const INPUT_WIDER_WIDTH = 450 as const // [px]
